function getOffsetSizes(element) {
  let parent = element;
  let x = -window.pageXOffset;
  let y = -window.pageYOffset;
  while (parent) {
    x += parent.offsetLeft;
    y += parent.offsetTop;
    parent = parent.offsetParent;
  }
  const width = element.offsetWidth;
  const height = element.offsetHeight;
  return {
    x,
    y,
    width,
    height,
    top: y,
    right: width + x,
    bottom: height + y,
    left: x
  };
}
export {
  getOffsetSizes as default
};
//# sourceMappingURL=getOffsetSizes.js.map
